import {
    CHAIN_ID_TO_NETWORK,
    getChainInfo,
    isSupportedNetwork,
    Network,
    NETWORK_TO_CHAIN_ID,
    SupportedNetwork,
} from '@spritz-finance/sdk'
import { Connector } from '@web3-react/types'
import { useCallback } from 'react'
import { networkConnection, walletConnectConnection } from '../connection/connection'
import { getPublicRpcUrl } from '../connection/constants'
import { useWeb3Connection } from '../Web3Provider'

export const switchChain = async (connector: Connector, network: SupportedNetwork) => {
    const chainId = NETWORK_TO_CHAIN_ID[network]
    if (!isSupportedNetwork(chainId)) {
        throw new Error(`Network ${chainId} not supported for connector (${typeof connector})`)
    }
    if (
        connector === walletConnectConnection.connector ||
        connector === networkConnection.connector
    ) {
        await connector.activate(chainId)
    } else {
        const info = getChainInfo(network)
        const addChainParameter = {
            chainId,
            chainName: info?.name,
            rpcUrls: [getPublicRpcUrl(network)],
            nativeCurrency: info.nativeCurrency,
            blockExplorerUrls: [info.blockExplorerUrl],
        }
        await connector.activate(addChainParameter)
    }
}

export const useSwitchNetwork = () => {
    const { chainId, connector } = useWeb3Connection()

    const switchNetwork = useCallback(
        (network: SupportedNetwork = Network.Polygon) => {
            if (chainId && CHAIN_ID_TO_NETWORK[chainId] === network) return
            switchChain(connector, network)
        },
        [chainId, connector]
    )

    return { switchNetwork }
}
